import GalleryForm from "../component/GalleryForm";
const AddGalleryImage = () => { return (<GalleryForm />) }
export default AddGalleryImage;